const KeyMirror = require('keymirror');

module.exports = KeyMirror({
    SETUP_USER: true,
    REMOVE_FLAGS_BEGIN: true,
    REMOVE_FLAGS_SUCCESS: true,
    REMOVE_FLAGS_ERROR: true,
});
